import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { useAnalytics } from '@/hooks/useAnalytics'
import { EventName } from '@/utils/eventDefinitions'

export const usePageViewTracking = () => {
  const location = useLocation()
  const { trackEvent } = useAnalytics()

  useEffect(() => {
    trackEvent?.(EventName.PageViewed, { page_path: location.pathname })
  }, [location.pathname, trackEvent])
}
